<template>
  <v-card class="px-5 py-3 mb-4 elevation-5" column>
    <v-layout column>
      <v-layout row wrap align-center justify-space-between>
        <h4 class="subheading font-weight-black primary--text my-3">
          {{ titlePinss }}
        </h4>
        <v-btn
          v-if="showPin"
          class="mx-0"
          :color="highContrast ? 'white' : 'primary'"
          @click="download"
          outline
          >Baixar</v-btn
        >
      </v-layout>
      <h5 class="body-2 mb-3">
        {{ titlePortalAcesso }}
      </h5>
      <v-layout justify-start row>
        <v-btn
          v-if="!showPin"
          class="mx-0"
          outline
          :color="highContrast ? 'white' : 'primary'"
          @click="showPin = true"
          >GERAR PIN-SS</v-btn
        >
      </v-layout>
    </v-layout>
    <v-layout justify-center column style="overflow: auto">
      <v-flex
        v-if="showPin"
        id="pinss"
        fill-height
        style="min-width: 900px; max-width: 1000px; margin: auto"
        class="pinss body-white"
        :class="{ 'print-dark-mode': printDarkMode }"
      >
        <v-layout justify-space-between align-center row class="px-5 py-4">
          <h3 class="mb-0">
            {{ beneficiarioPinss ? beneficiarioPinss.operadoraRazaoSocial : ""
            }}<br />
            SGU Portais - Portal Beneficiário
          </h3>
          <v-img
            contain
            width="126"
            height="45"
            max-width="126"
            :src="logoUnimed"
          ></v-img>
        </v-layout>
        <v-divider></v-divider>
        <v-layout justify-center column class="px-5 py-4">
          <h5 class="mb-3 text-xs-center green--text">
            {{ titlePortalInformacoes }}
          </h5>
          <v-layout row>
            <v-flex xs6 class="pa-2">
              <beneficiario
                :beneficiarioPinss="this.beneficiarioPinss"
              ></beneficiario>
            </v-flex>
            <v-flex xs6 class="pa-2">
              <plano :beneficiarioPinss="this.beneficiarioPinss"></plano>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6 class="pa-2">
              <carencias
                :beneficiarioPinss="this.beneficiarioPinss"
              ></carencias>
            </v-flex>
            <v-flex xs6 class="pa-2">
              <contrato :beneficiarioPinss="this.beneficiarioPinss"></contrato>
            </v-flex>
          </v-layout>
          <v-layout row v-if="this.exibeDadosReajuste">
            <v-flex xs6 class="pa-2"></v-flex>
            <v-flex xs6 class="pa-2">
              <dados-reajuste
                :dados-reajuste="this.pinssReajuste"
              ></dados-reajuste>
            </v-flex>
          </v-layout>
          <v-layout row class="pb-3">
            <v-flex xs6 class="pa-2">
              <contratante
                :beneficiarioPinss="this.beneficiarioPinss"
              ></contratante>
            </v-flex>
            <v-flex xs6 class="pa-2">
              <operadora-contratada
                :beneficiarioPinss="this.beneficiarioPinss"
              ></operadora-contratada>
            </v-flex>
          </v-layout>
          <small
            class="caption"
            v-if="beneficiarioPinss && beneficiarioPinss.listaGrupoMunicipios"
          >
            *Grupo de Municípios de Atendimento:
            {{
              beneficiarioPinss
                ? " " + beneficiarioPinss.listaGrupoMunicipios
                : ""
            }}
          </small>
          <v-divider class="mb-3"></v-divider>
          <v-layout row>
            <v-flex xs4 class="pa-2">
              <contato :beneficiarioPinss="this.beneficiarioPinss"></contato>
            </v-flex>
            <v-flex xs4 class="pa-2">
              <ans :beneficiarioPinss="this.beneficiarioPinss"></ans>
            </v-flex>
            <v-flex xs4 class="pa-2">
              <unimed :beneficiarioPinss="this.beneficiarioPinss"></unimed>
            </v-flex>
          </v-layout>
          <v-layout row justify-center="">
            <small class="caption">
              Data e hora da geração:
              {{ dataHoraAtual }}
            </small>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-btn
      v-if="showPin"
      color="grey"
      dark
      class="mx-0"
      @click="showPin = false"
      >OCULTAR PIN-SS</v-btn
    >
  </v-card>
</template>

<script>
import Beneficiario from "./beneficiario";
import Plano from "./plano";
import Carencias from "./carencias";
import Contrato from "./contrato";
import DadosReajuste from "./dados-reajuste";
import Contratante from "./contratante";
import OperadoraContratada from "./operadora-contratada";
import Contato from "./contato";
import { getParametro } from "@/services/beneficiario";
import { FORMACAO_PRECO_PLANO, PARAMETROS } from "@/constants";
import Ans from "./ans";
import Unimed from "./unimed";
import { createNamespacedHelpers } from "vuex";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getPinss } from "@/services/beneficiario";
import { currentDate } from "@/utils/date";
import logoUnimed from "../../assets/unimed-logo-1.png";

const beneficiarioStore = createNamespacedHelpers("beneficiario");
const portalStore = createNamespacedHelpers("portal");

export default {
  name: "Pinss",
  data() {
    return {
      beneficiarioPinss: null,
      exibeDadosReajuste: false,
      showPin: false,
      pinssReajuste: null,
      printDarkMode: false,
      logoUnimed: logoUnimed
    };
  },
  async created() {
    await this.getPinss();
  },
  components: {
    Beneficiario,
    Plano,
    Carencias,
    Contrato,
    Contratante,
    OperadoraContratada,
    Contato,
    Ans,
    Unimed,
    DadosReajuste
  },
  computed: {
    ...beneficiarioStore.mapState(["dadosBeneficiario"]),
    ...portalStore.mapState(["highContrast"]),
    beneficiarioCartao() {
      return this.dadosBeneficiario.id;
    },
    dataHoraAtual() {
      return currentDate;
    },
    titlePinss() {
      return "PIN-SS - Portal de Informações do Beneficiário da Saúde Suplementar";
    },
    titlePortalAcesso() {
      return (
        "Portal de acesso as informações individualizadas de dados cadastrais dos " +
        "beneficiários titulares e dependentes e seu respectivo plano de saúde."
      );
    },
    titlePortalInformacoes() {
      return " PORTAL DE INFORMAÇÕES DO BENEFICIÁRIO DA SAÚDE SUPLEMENTAR (PIN-SS)";
    }
  },
  watch: {
    beneficiarioCartao: {
      handler() {
        this.getPinss();
      }
    }
  },
  methods: {
    download() {
      const documentPDF = new jsPDF("p");
      window.scrollTo(0, 0);
      this.printDarkMode = true;
      global.setTimeout(() => {
        const element = document.querySelector("#pinss");
        document.fonts.ready.then(() => {
          html2canvas(element, { scale: 1.5 }).then(canvas => {
            const marginRight = 8;
            const marginTop = 20;
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const imgData = canvas.toDataURL("image/png");
            const pageWidth = documentPDF.internal.pageSize.getWidth();
            const pageHeight = (imgHeight * pageWidth) / imgWidth;

            documentPDF.addImage(
              imgData,
              "JPEG",
              marginRight,
              marginTop,
              pageWidth - marginRight * 2,
              pageHeight
            );

            documentPDF.save("pin-ss.pdf");
          });
        });
        this.printDarkMode = false;
      }, 200);
    },
    async getPinss() {
      await getPinss(this.dadosBeneficiario.id).then(
        ({ pinssApb, pinssReajusteApb }) => {
          this.beneficiarioPinss = pinssApb;
          this.pinssReajuste = pinssReajusteApb;
        }
      );

      const paramDadosReajuste =
        (await getParametro(PARAMETROS.HABILITAR_DADOS_REAJUSTE_PINSS)) ===
        "true";

      this.exibeDadosReajuste =
        paramDadosReajuste &&
        this.beneficiarioPinss.planoFormPreco == FORMACAO_PRECO_PLANO.VD;
    }
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}
.print-dark-mode {
  color: black !important;
}
</style>
